export default __webpack_public_path__ + "static/media/916.0ccb2733.gif";